<template>
  <q-step :name="name" :title="title" :done="done" :header-nav="headerNav">
    <slot />

    <q-stepper-navigation>
      <div class="row justify-between items-center">
        <div>
          <Button flat @click="handleCancel" :label="$t('Cancel')" />
        </div>

        <div class="q-gutter-sm">
          <Button
            flat
            @click="handlePrevious"
            :label="$t('Back')"
            icon="chevron_left"
            class="pl-md pr-md"
            v-if="!hideBackBtn"
          />

          <Button
            :label="submitLabel ? submitLabel : $t('Done')"
            @click="handleSubmit"
            class="pl-md pr-md"
            v-if="submit"
          />

          <Button
            :label="$t('Next')"
            icon-right="chevron_right"
            @click="handleNext"
            class="pl-md pr-md"
            v-else
          />
        </div>
      </div>
    </q-stepper-navigation>
  </q-step>
</template>

<script>
import Button from './Button';

const messages = {
  en: {
    Cancel: 'Cancel',
    Next: 'Next',
    Back: 'Back',
    Done: 'Done',
  },
  ja: {
    Cancel: 'キャンセル',
    Next: '次へ',
    Back: '戻る',
    Done: '終わる',
  },
};

export default {
  name: 'Step',
  i18n: { messages },
  components: { Button },
  props: {
    title: {
      type: String,
      required: true,
    },
    name: {
      type: Number,
      required: true,
    },
    done: {
      type: Boolean,
    },
    headerNav: {
      type: Boolean,
      required: true,
    },
    validate: {
      type: Boolean,
      default: false,
    },
    submit: {
      type: Boolean,
      default: false,
    },
    submitLabel: {
      type: String,
    },
    hideBackBtn: {
      type: Boolean,
    },
  },
  methods: {
    handleInput(val) {
      this.$emit('change', val);
    },

    handleNext() {
      if (this.validate) this.$emit('validate');
      this.$emit('next');
    },

    handleSubmit() {
      if (this.validate) this.$emit('validate');
      this.$emit('submit');
    },

    handlePrevious() {
      this.$emit('previous');
    },

    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped></style>
